import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  DragSource,
  DropTarget,
} from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import {
  Button,
  Card,
  CardBody,
  Collapse,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { showModal } from '../../../actions';

import AdminPageSectionHeader from './SectionHeader';
import AdminPageEditCollectionsList from './CollectionsList';

import ItemTypes from '../../../helpers/DNDItemTypes';
import {
  pageSectionsTarget,
  pageSectionsSource,
} from '../../../helpers/DNDPageSections';

class AdminPageSectionCollectionFullWidth extends PureComponent {
  constructor(props) {
    super(props);

    this.openCollectionSelectModal = this.openCollectionSelectModal.bind(this);
    this.handleChangeCollection = this.handleChangeCollection.bind(this);
    this.handleAddCollection = this.handleAddCollection.bind(this);
    this.handleDeleteCollection = this.handleDeleteCollection.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    const { connectDragPreview } = this.props;

    if (connectDragPreview) {
      connectDragPreview(getEmptyImage(), {
        captureDraggingState: true,
      });
    }
  }

  openCollectionSelectModal() {
    const { dispatch } = this.props;

    dispatch(showModal('CollectionSelectModal', {
      className: 'modal-collection-select',
      backdrop: true,
      handleCollectionSelect: this.handleAddCollection,
    }));
  }

  handleChangeCollection(e) {
    const {
      section,
      handleChangeSection,
    } = this.props;
    const {
      name,
      value,
    } = e.target;

    if (section.collection) {
      section.collection[name] = value;
      section.collection.timestamp = new Date();
    }
    handleChangeSection(section);
  }

  handleAddCollection(collection) {
    const {
      section,
      handleChangeSection,
    } = this.props;

    section.collection = {
      id: uuidv4(),
      ...collection,
    };
    handleChangeSection(section);
  }

  handleDeleteCollection() {
    const {
      section,
      handleChangeSection,
    } = this.props;

    section.collection = null;
    handleChangeSection(section);
  }

  handleChange(e) {
    const {
      section,
      handleChangeSection,
    } = this.props;
    const {
      name,
      value,
      type,
      checked,
    } = e.target;

    if (type === 'checkbox') {
      section[name] = checked;
    } else {
      section[name] = value;
    }
    handleChangeSection(section);
  }

  render() {
    const {
      intl,
      id,
      section,
      sectionIndex,
      sectionsCount,
      isClosed,
      isDragging,
      handleDeleteSection,
      handleSwitchSection,
      handleMoveSectionByIndex,
      connectDragSource,
      connectDropTarget,
    } = this.props;

    return (
      connectDragSource(connectDropTarget((
        <div id={`s-${id}`} className={classnames('section-container', `section-${section.section}`, { dragging: isDragging })}>
          <Card>
            <AdminPageSectionHeader
              section={section}
              sectionIndex={sectionIndex}
              sectionsCount={sectionsCount}
              isClosed={isClosed}
              handleDeleteSection={handleDeleteSection}
              handleSwitchSection={handleSwitchSection}
              handleMoveSection={handleMoveSectionByIndex}
            />
            <Collapse isOpen={!isClosed}>
              <CardBody>
                <Button
                  onClick={this.openCollectionSelectModal}
                >
                  {intl.formatMessage({ defaultMessage: 'Select Collection' })}
                </Button>
                <AdminPageEditCollectionsList
                  collections={section.collection ? [section.collection] : []}
                  singleCollection={true}
                  handleChangeCollection={this.handleChangeCollection}
                  handleDeleteCollection={this.handleDeleteCollection}
                />
              </CardBody>
            </Collapse>
          </Card>
        </div>
      )))
    );
  }
}

AdminPageSectionCollectionFullWidth.propTypes = {
  intl: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  section: PropTypes.object.isRequired,
  sectionIndex: PropTypes.number.isRequired,
  sectionsCount: PropTypes.number.isRequired,
  isClosed: PropTypes.bool.isRequired,
  handleChangeSection: PropTypes.func.isRequired,
  handleDeleteSection: PropTypes.func.isRequired,
  handleSwitchSection: PropTypes.func.isRequired,
  handleMoveSectionByIndex: PropTypes.func.isRequired,
};

export default
DragSource(ItemTypes.PAGE_SECTION, pageSectionsSource, (DNDconnect, monitor) => ({
  connectDragSource: DNDconnect.dragSource(),
  connectDragPreview: DNDconnect.dragPreview(),
  isDragging: monitor.isDragging(),
}))(DropTarget(ItemTypes.PAGE_SECTION, pageSectionsTarget, DNDconnect => ({
  connectDropTarget: DNDconnect.dropTarget(),
}))(connect()(injectIntl(AdminPageSectionCollectionFullWidth))));
